import React, { useState, useEffect } from 'react';
import { Grid } from 'components/mui';
import { Checkbox, FormControlLabel, Box } from '@mui/material';
import { CaseFormData } from 'containers/pages/cases/types';
import { searchKeywords, searchReferences, TagOption } from 'api/cases/searchKeywordsAndReferences';
import { FormAutocompleteMulti } from 'containers/pages/cases/components/caseForm/FormAutocomplete';
import FormSection from 'containers/pages/cases/components/caseForm/FormSection';

interface TagsAndConfigSectionProps {
	form: CaseFormData;
	onKeywordsChange: (_event: unknown, value: TagOption[]) => void;
	onReferencesChange: (_event: unknown, value: TagOption[]) => void;
	onCheckboxChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const TagsAndConfigSection: React.FC<TagsAndConfigSectionProps> = ({
	form,
	onKeywordsChange,
	onReferencesChange,
	onCheckboxChange,
}) => {
	const [keywords, setKeywords] = useState<TagOption[]>([]);
	const [references, setReferences] = useState<TagOption[]>([]);

	useEffect(() => {
		searchKeywords('').then(setKeywords).catch(() => {});
		searchReferences('').then(setReferences).catch(() => {});
	}, []);

	const keywordOptions = [
		...form.KeywordTags,
		...keywords.filter((k) => !form.Keywords.includes(k.Id)),
	];
	const referenceOptions = [
		...form.ReferenceTags,
		...references.filter((r) => !form.References.includes(r.Id)),
	];

	const filledCount =
		form.KeywordTags.length +
		form.ReferenceTags.length +
		(form.Private ? 0 : 1) +
		(form.IpRestricted ? 0 : 1);

	return (
		<FormSection
			title="Tags & Configuration"
			collapsible
			defaultExpanded={filledCount > 0}
			fieldCount={filledCount}
		>
			<Grid container spacing={2}>
				<Grid item xs={12} sm={6}>
					<FormAutocompleteMulti
						label="Keywords"
						options={keywordOptions}
						value={form.KeywordTags}
						onChange={onKeywordsChange}
						getOptionLabel={(opt) => opt.Title}
						onSearch={(val) => searchKeywords(val).then(setKeywords).catch(() => {})}
					/>
				</Grid>
				<Grid item xs={12} sm={6}>
					<FormAutocompleteMulti
						label="References"
						options={referenceOptions}
						value={form.ReferenceTags}
						onChange={onReferencesChange}
						getOptionLabel={(opt) => opt.Title}
						onSearch={(val) => searchReferences(val).then(setReferences).catch(() => {})}
					/>
				</Grid>
				<Grid item xs={12}>
					<Box sx={{ display: 'flex', gap: 3 }}>
						<FormControlLabel
							control={
								<Checkbox
									checked={form.Private}
									onChange={onCheckboxChange}
									name="Private"
								/>
							}
							label="Private"
						/>
						<FormControlLabel
							control={
								<Checkbox
									checked={form.IpRestricted}
									onChange={onCheckboxChange}
									name="IpRestricted"
								/>
							}
							label="IP Restricted"
						/>
					</Box>
				</Grid>
			</Grid>
		</FormSection>
	);
};

export default TagsAndConfigSection;
